import React from 'react';

// Wraps a trusted (already-sanitized) HTML string as a React node so it can be
// handed to a component prop that renders arbitrary markup. Pair with
// `sanitizeHtml` at the call site: `htmlNode(sanitizeHtml(raw, options))`.
//
// `dangerouslySetInnerHTML` needs a real host element (a Fragment can't carry
// it), so pick `tag` to match the content's context: the default inline `span`
// suits phrasing-only content, but pass a block tag (e.g. `div`) when the markup
// may contain block-level elements so the wrapper nesting stays valid HTML.
export function htmlNode(html, tag = 'span') {
  return React.createElement(tag, {dangerouslySetInnerHTML: {__html: html}});
}
